module.exports = __webpack_public_path__ + "img/empty.43832d8f.svg";